module.exports = __webpack_public_path__ + "static/media/Me3.9a72c984.jpg";